import React from "react";
import "./WelcomeSection.css";

import rightImg from "../Assets/right-side-leaf.png";
import checkIcon1 from "../Assets/Certified.svg"; 
import checkIcon2 from "../Assets/Adulterants.svg"; 
import checkIcon3 from "../Assets/Preservatives.svg"; 
import checkIcon4 from "../Assets/Chemicals.svg"; 
import checkIcon5 from "../Assets/Impurities.svg"; 

const WelcomeSection = () => {
  return (
    <section className="vf-welcome-section">

      {/* FLOATING RIGHT IMAGE */}
      <img src={rightImg} alt="floating leaf" className="vf-floating-right-img anim anim-top" />

      <div className="vf-welcome-container">

        {/* LEFT CONTENT */}
        <div className="vf-welcome-left anim anim-top">
          <h2 className="vf-title">Welcome to the Green Haven – Vangal Farms</h2>
          <h3 className="vf-subtitle">Pure Dairy. Timeless Family Tradition</h3>

          <p className="vf-description">
            Founded in 1993, Vangal Dairies blends tradition with quality. Backed by a family dairy legacy and led by Navy veteran Lt. S. Balachandar, our handcrafted VANGAL and GOPIKA products are ethically sourced, preservative-free, and made to deliver the authentic taste of homemade dairy.
          </p>

          {/* FEATURES */}
          <div className="vf-features anim anim-bottom">
            <div className="vf-feature-item">
              <img src={checkIcon1} alt="check" className="vf-icon-img" />
              <p>Fully Certified<br /></p>
            </div>

            <div className="vf-feature-item">
              <img src={checkIcon2} alt="check" className="vf-icon-img" />
              <p>No Adulterants</p>
            </div>

            <div className="vf-feature-item">
              <img src={checkIcon3} alt="check" className="vf-icon-img" />
              <p>No Preservatives</p>
            </div>

            <div className="vf-feature-item">
              <img src={checkIcon4} alt="check" className="vf-icon-img" />
              <p>No Chemicals</p>
            </div>

            <div className="vf-feature-item">
              <img src={checkIcon5} alt="check" className="vf-icon-img" />
              <p>No Impurities</p>
            </div>
          </div>

          <a href="/about" className="vf-about-btn anim anim-top">
  More About Us <span className="vf-arrow">➜</span>
</a>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
